// frontend/src/hooks/useMustReads.ts
// The viewer's outstanding must-reads (requires_ack feed posts they're in the
// audience for and haven't acked yet), oldest first — GET /feed/must-reads.
// Powers the app-wide MustReadBanner. Manual fetch+state pattern, consistent
// with the other comms hooks (no React Query). Any error is treated as an
// empty list so the banner stays silent on non-messaging tenants / guests /
// when the endpoint 403s.
import { useCallback, useEffect, useState } from 'react'
import api from '../utils/api'

export interface MustReadItem {
  id: number
  body: string
  space_id: number
  created_at: string
}

export function useMustReads() {
  const [items, setItems] = useState<MustReadItem[]>([])
  const [loading, setLoading] = useState(true)

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const { data } = await api.get<{ items?: MustReadItem[] }>('/feed/must-reads')
      setItems(Array.isArray(data?.items) ? data.items : [])
    } catch {
      // Silent: non-messaging tenant, guest, or 403 — render nothing.
      setItems([])
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { load() }, [load])

  return { items, count: items.length, loading, reload: load }
}

export default useMustReads
